<template>
  <div class="hearder">
    <div class="app-wrapper top">
      <h1
        @click="
          () => {
            $router.push({ path: '/' })
          }
        "
      >
        <img src="../../assets/logo.png" />
        <span>{{ COMPET_NAME }}</span>
      </h1>
      <Nav class="nav_mod" v-if="!isMobileDevice"></Nav>
    </div>
  </div>
</template>

<script>
import Nav from './nav.vue'
import { MENU_LIST } from '@/constants/common'
import { COMPET_NAME, SESSIONS_NUMBER } from '@/utils/config.js'

export default {
  components: { Nav },
  name: 'hearder',
  data() {
    return {
      MENU_LIST,
      COMPET_NAME,
      SESSIONS_NUMBER
    }
  },
  computed: {
    isMobileDevice() {
      return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.hearder {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: $--color-primary;
  z-index: 999;
}
.top {
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 {
    width: 550px;
    display: flex;
    align-items: center;
    img {
      height: 45px;
      margin-right: 20px;
    }
    span {
      display: block;
      color: #ffffff;
      padding: 5px;
      font-size: 22px;
      font-weight: 600;
      margin-right: 10px;
    }
  }
  .nav_mod {
    flex: 1;
  }
}
@media screen and (max-width: 750px) {
  .top {
    // height: 180px;
    display: block;
    h1 {
      width: 100%;
      span {
        font-size: 20px;
      }
    }
    .nav_mod {
      width: 100%;
      .el-menu {
        flex-wrap: wrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/hearder.vue